export const listingDetail = {
  breadcrumb: {
    listings: "Inserate",
    detailFallback: "Detail",
  },
  hero: {
    noName: "Ohne Namen",
    editNameTitle: "Namen bearbeiten",
    channelConnected: "Mit dem Channel verbunden (OTAs)",
    channelDisconnected: "Nicht mit dem Channel verbunden",
  },
  units: {
    unitsCount: "{count} Einheiten",
    roomsCount: "{count} Zimmer | {count} Zimmer",
    maxGuests: "Max. {count} Gäste",
    searchPlaceholder: "Einheit suchen…",
    dragTitle: "Zum Umsortieren ziehen",
    headerRoomTypes: "ZIMMERTYPEN",
    headerLinkedUnits: "VERKNÜPFTE EINHEITEN",
    addBtnTitle: "Einheit hinzufügen",
    movedBadge: "verschoben",
    unitFallback: "Einheit",
  },
  typeLabels: {
    apartment: "Apartment",
    house: "Haus",
    villa: "Villa",
    hotel: "Hotel",
    room: "Zimmer",
    studio: "Studio",
    fallback: "Unterkunft",
  },
  aiReception: {
    title: "KI-Rezeption",
  },
  toggles: {
    enableAgent: {
      label: "KI-Agent aktivieren",
      hint: "Automatisieren Sie den Gästesupport über WhatsApp.",
    },
    otaAgent: {
      label: "KI-Agent für OTAs",
      hintOn: "Antwortet auch auf Nachrichten von Booking, Airbnb und anderen OTAs.",
      hintOff: "Erfordert einen aktiven KI-Agenten.",
    },
  },
  status: {
    active: "Aktiv",
    inactive: "Inaktiv",
  },
  emptyUnits: {
    title: "Keine Einheiten",
    subHotel: "Legen Sie das erste Zimmer bzw. die erste Einheit dieses Hotels an, um Tarife und Verfügbarkeit einzurichten.",
    subDefault: "Fügen Sie diesem Inserat die erste Einheit hinzu, um Gäste zu empfangen.",
    ctaPreparing: "Wird vorbereitet…",
    ctaAddRoom: "Zimmer hinzufügen",
    ctaAddFirstUnit: "Erste Einheit hinzufügen",
  },
  sortBar: {
    add: "Hinzufügen",
    addRoom: "Zimmer hinzufügen",
    saving: "Wird gespeichert…",
    done: "Fertig",
    sort: "Sortieren",
    dragHint: "Zum Umsortieren ziehen",
  },
  propOptions: {
    scheduled: "Geplante Nachrichten",
    services: "Ausstattung und Annehmlichkeiten",
    locks: "Schlösser",
    faq: "FAQ",
    arrival: "Anreisehinweise",
    checkout: "Check-out-Nachricht",
    welcome: "Willkommensnachricht",
    description: "Beschreibung",
    capacity: "Kapazität",
  },
  addZone: {
    titleRoom: "Zimmer hinzufügen",
    titleUnit: "Einheit hinzufügen",
    roomLower: "Zimmer",
    unitLower: "Einheit",
    createNew: "{noun} darin neu anlegen",
    eachHas: "Pro {noun} eigene Einstellungen: Beschreibung, Kapazität, Zugang…",
    ctaPreparing: "Wird vorbereitet…",
    ctaCreateRoom: "Zimmer anlegen",
    ctaCreateUnit: "Einheit anlegen",
  },
  danger: {
    deleteListing: "Inserat löschen...",
    notePrefix: "Löscht das Inserat",
    noteSuffix: " und alle zugehörigen Einheiten aus WACheckin. Diese Aktion kann nicht rückgängig gemacht werden.",
  },
  toast: {
    orderSaved: "Reihenfolge erfolgreich gespeichert",
  },
  errors: {
    loadListing: "Die Unterkunft konnte nicht geladen werden.",
  },
  authorities: {
    title: "Behörden",
    description: "Richten Sie die Verbindung zu den Behörden für die automatische Übermittlung der Gästemeldungen ein.",
  },
  cards: {
    knowledge: { title: "Wissensdatenbank", status: "Informationen, die der Agent nutzt" },
    earlyAccess: { title: "Früher Zugang", status: "Ankunftszeiten und früher Check-in" },
    lateCheckout: { title: "Später Check-out", status: "Später Check-out und Preis" },
    extendStay: { title: "Aufenthalt verlängern", status: "Nächte der Buchung verlängern" },
    invoicing: { title: "Rechnungsstellung", status: "Steuerdaten · Verifactu-tauglich" },
    location: { title: "Standort", sub: "Adresse der Unterkunft" },
    logo: { title: "Branding", sub: "Visuelle Identität" },
    welcome: { title: "Willkommensnachricht", sub: "Begrüßung anpassen" },
    checkin: { title: "Check-in", sub: "Zugangshinweise und Zeiten" },
    policies: { title: "Unterkunftsrichtlinien", sub: "Regeln und Bedingungen" },
    authorities: { sub: "Meldung an die Behörden" },
    hotelRates: { title: "Hoteltarife", sub: "Basistarife und abgeleitete Tarife" },
    roomManagement: { title: "Zimmer", sub: "Zimmertypen und Bestand" },
    rates: { title: "Tarife", sub: "Basistarife und abgeleitete Tarife" },
    ota: { title: "OTA verbinden", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Erfordert ein aktives Abonnement" },
    ical: { title: "iCal-Kalender", sub: "Kalendersynchronisierung" },
    ownerSettlement: { title: "Eigentümer und Abrechnung", sub: "Wenn Sie sie für einen anderen Eigentümer verwalten: Provision und Abrechnung", subManaged: "Verwaltet für {owner} · {pct}\u00a0%", subManagedNoOwner: "Verwaltet · {pct}\u00a0% · kein Eigentümer zugewiesen" },
    otaCommissions: { title: "OTA-Provisionen", sub: "Was jede OTA einbehält und was bei Ihnen ankommt", subActive: "Die Buchungsdetails zeigen, was bei Ihnen ankommt" },
    description: { title: "Beschreibung", sub: "Details der Einheit" },
    capacity: { title: "Kapazität", sub: "Gäste und Betten" },
    services: { title: "Ausstattung und Annehmlichkeiten", sub: "Was es bietet, mit Fotos" },
    unitFaq: { title: "FAQ", sub: "Speziell für diese Einheit, für den Agenten" },
    rules: { title: "Zeiten", sub: "Check-in- und Check-out-Zeiten" },
    upselling: { title: "Erlebnisse und Services", sub: "Upselling-Services" },
    checkinStore: { title: "Check-in-Shop", sub: "Beim Einchecken an den Gast senden" },
    bookingConfirmation: { title: "Neue Buchung melden", sub: "Wir benachrichtigen den Gast auf WhatsApp, sobald seine Buchung bestätigt ist" },
    arrivalInstructions: { title: "Anreisehinweise", sub: "Anfahrt und Zutritt · mit Sendezeit" },
    checkoutMessage: { title: "Check-out-Nachricht", sub: "Check-out-Erinnerung · Vorlage" },
    scheduledMessages: { title: "Geplante Nachrichten", sub: "Automatische Nachrichten vor, während und nach dem Aufenthalt" },
    review: { title: "Bewertung anfragen", sub: "Ruf der Unterkunft" },
    identity: { title: "Identitätsprüfung", sub: "Sicherheit der Gäste" },
    journeySim: { title: "Gästereise simulieren", sub: "Spielt den gesamten Ablauf auf WhatsApp nach · zum Testen an ein Telefon senden" },
    smartlocks: { title: "Schlösser und Zugang", sub: "Wie der Gast hineinkommt" },
    integrations: { title: "Verbindungen und Integrationen", sub: "Weitere APIs und Verbindungen" },
    welcomeInline: { sub: "Nachricht speziell für diese Einheit" },
    newBookings: { title: "Neue Buchungen" },
  },
  badges: {
    ai: "KI",
    setup: "Setup",
    hotel: "Hotel",
    subscription: "Abo",
    comingSoon: "Demnächst",
    test: "Test",
    manager: "Verwalter",
    active: "Aktiv",
  },
  sections: {
    essential: { title: "Grundeinrichtung", description: "Grundeinstellungen, die zum Veröffentlichen und Verwalten der Unterkunft nötig sind." },
    management: { title: "Unterkunftsverwaltung", description: "Richten Sie Tarife, Verfügbarkeit und Vertriebskanäle ein." },
    direct: { title: "Diese Einheit ausarbeiten", description: "Zusätzliche Informationen, die wir für Direktbuchungen und für den KI-Agenten nutzen." },
    guest: { title: "Gästeerlebnis", description: "Richten Sie die Kommunikation vor, während und nach dem Aufenthalt ein." },
    access: { title: "Zugang und Integrationen", description: "Verwalten Sie Zugang, Schlösser und externe Verbindungen." },
  },
  otaModal: {
    title: "OTA-Verbindung",
    html: "Für die Anbindung von Booking, Airbnb, Vrbo und Expedia (channel manager) ist ein <b>aktives Abonnement</b> erforderlich.<br><small>In der Zwischenzeit können Sie alle übrigen Funktionen nutzen und Kalender per iCal synchronisieren (kostenlos).</small>",
    confirm: "Abonnement aktivieren",
    cancel: "Jetzt nicht",
  },
};
